/* src/app/layers-tree/layers-tree.component.css */
:host {
  display: block;
  line-height: 1.1;
  --slider-fixed-width: 220px;
  --slider-edge-padding: 10px;
}
:host ::ng-deep .p-tree {
  border: 0;
  border-radius: 0;
  background: #f1f1f1;
  color: #9b9b9b;
}
:host ::ng-deep .p-tree-container {
  border: 0;
  padding: 0 !important;
}
:host ::ng-deep .p-tree-container > ul {
  margin: 0 !important;
  padding: 0 !important;
}
:host ::ng-deep .p-tree-node,
:host ::ng-deep .p-tree-node-content,
:host ::ng-deep .p-tree-node-label {
  box-sizing: border-box;
}
:host ::ng-deep .p-treenode,
:host ::ng-deep .p-treenode-content,
:host ::ng-deep .p-treenode-label {
  box-sizing: border-box;
}
:host ::ng-deep .p-tree-node-content,
:host ::ng-deep .p-treenode-content {
  display: flex;
  align-items: center;
  width: 100%;
  margin: 0;
  padding: 6px 6px;
  background: inherit;
  font-family: "Roboto" !important;
  font-size: 13px !important;
  overflow: visible;
}
:host ::ng-deep .p-tree-node-label,
:host ::ng-deep .p-treenode-label {
  flex: 1 1 auto;
  min-width: 0;
  width: 100%;
  overflow: visible;
}
:host ::ng-deep .p-tree-node-children,
:host ::ng-deep .p-treenode-children {
  padding: 2px 0 2px 14px !important;
  background: #fff;
}
:host ::ng-deep .tree-rowwrap {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}
:host ::ng-deep .tree-line {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
}
:host ::ng-deep .tree-iconcell {
  flex: 0 0 22px;
  width: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
}
:host ::ng-deep .tree-labelcell {
  flex: 1 1 auto;
  min-width: 0;
}
:host ::ng-deep .nodeLabel {
  padding-top: 2px;
  cursor: pointer;
  color: #4b4b4b !important;
}
:host ::ng-deep .rootFont {
  color: #4b4b4b !important;
}
:host ::ng-deep div.nodeLabel.childTreeNodeLabel {
  color: #4b4b4b;
}
:host ::ng-deep .tree-labelcell .nodeLabel {
  white-space: normal !important;
  overflow: hidden !important;
  text-overflow: clip !important;
  display: -webkit-box !important;
  -webkit-box-orient: vertical !important;
  -webkit-line-clamp: 2 !important;
  line-clamp: 2 !important;
  overflow-wrap: anywhere !important;
  word-break: break-word !important;
}
:host ::ng-deep .rootFont {
  font-family: "Gidole";
  font-size: 15px;
}
:host ::ng-deep .row {
  margin-left: 0 !important;
  margin-right: 0 !important;
}
:host ::ng-deep .col {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
:host ::ng-deep .tree-fixed {
  width: var(--slider-fixed-width) !important;
  max-width: var(--slider-fixed-width) !important;
  box-sizing: border-box !important;
}
:host ::ng-deep .legendPanel {
  padding: 0;
  width: 100%;
  overflow: visible !important;
}
:host ::ng-deep .p-select.tree-dropdown,
:host ::ng-deep .tree-dropdown.p-select {
  display: flex !important;
  align-items: center !important;
  width: 100% !important;
  border: 1px solid #ced4da !important;
  box-sizing: border-box !important;
  margin: 2px 0;
}
:host ::ng-deep .tree-dropdown.p-select .p-select-label {
  flex: 1 1 auto !important;
  white-space: normal !important;
  overflow: visible !important;
  text-overflow: clip !important;
  overflow-wrap: anywhere !important;
  word-break: break-word !important;
  line-height: 14px !important;
  padding-top: 8px !important;
  padding-bottom: 8px !important;
  height: auto !important;
  min-height: 34px !important;
}
:host ::ng-deep .p-select-panel {
  position: absolute !important;
  z-index: 99999 !important;
  max-width: 90vw !important;
}
:host ::ng-deep .p-select-panel .p-select-item.p-highlight {
  background-color: #EFC98C !important;
}
:host ::ng-deep .layerOpacitySlider.p-slider,
:host ::ng-deep .layerOpacitySlider.p-slider.p-slider-horizontal {
  width: 100% !important;
  max-width: 100% !important;
  box-sizing: border-box !important;
  margin: 12px 0 !important;
  padding: 0 var(--slider-edge-padding) !important;
  overflow: visible !important;
}
:host ::ng-deep .layerOpacitySlider.p-slider.p-slider-horizontal {
  height: 4px !important;
}
:host ::ng-deep .layerOpacitySlider .p-slider-handle {
  width: 14px !important;
  height: 14px !important;
  border-radius: 50% !important;
  top: 50% !important;
  transform: translate(-50%, -50%) !important;
  background: #9b9b9b !important;
  border: 3px solid #ffffff !important;
  box-shadow: none !important;
  z-index: 5 !important;
  margin: 0 !important;
}
:host ::ng-deep .layerOpacitySlider .p-slider-handle::before,
:host ::ng-deep .layerOpacitySlider .p-slider-handle::after {
  content: none !important;
}
:host ::ng-deep .layerOpacitySlider,
:host ::ng-deep .layerOpacitySlider * {
  cursor: pointer !important;
}
:host ::ng-deep .PrometBg > :first-child > .p-tree-node-content,
:host ::ng-deep .PrometBg > :first-child > .p-treenode-content,
:host ::ng-deep .PrometBg:first-child > div {
  background-color: #EDDA6B !important;
  color: white !important;
}
:host ::ng-deep .PrometBg .layerOpacitySlider .p-slider-range,
:host ::ng-deep .PrometBg .layerOpacitySlider .p-slider-handle {
  background: #EDDA6B !important;
  border-color: #EDDA6B !important;
}
:host ::ng-deep .RabaEnergijeBg > :first-child > .p-tree-node-content,
:host ::ng-deep .RabaEnergijeBg > :first-child > .p-treenode-content,
:host ::ng-deep .RabaEnergijeBg:first-child > div {
  background-color: #EFC98C !important;
  color: white !important;
}
:host ::ng-deep .RabaEnergijeBg .layerOpacitySlider .p-slider-range,
:host ::ng-deep .RabaEnergijeBg .layerOpacitySlider .p-slider-handle {
  background: #EFC98C !important;
  border-color: #EFC98C !important;
}
:host ::ng-deep .OskrbaZEnergijoBg > :first-child > .p-tree-node-content,
:host ::ng-deep .OskrbaZEnergijoBg > :first-child > .p-treenode-content,
:host ::ng-deep .OskrbaZEnergijoBg:first-child > div {
  background-color: #D4BFAC !important;
  color: white !important;
}
:host ::ng-deep .OskrbaZEnergijoBg .layerOpacitySlider .p-slider-range,
:host ::ng-deep .OskrbaZEnergijoBg .layerOpacitySlider .p-slider-handle {
  background: #D4BFAC !important;
  border-color: #D4BFAC !important;
}
:host ::ng-deep .OmejitveVProstoruBg > :first-child > .p-tree-node-content,
:host ::ng-deep .OmejitveVProstoruBg > :first-child > .p-treenode-content,
:host ::ng-deep .OmejitveVProstoruBg:first-child > div {
  background-color: #EF988C !important;
  color: white !important;
}
:host ::ng-deep .OmejitveVProstoruBg .layerOpacitySlider .p-slider-range,
:host ::ng-deep .OmejitveVProstoruBg .layerOpacitySlider .p-slider-handle {
  background: #EF988C !important;
  border-color: #EF988C !important;
}
:host ::ng-deep .KlimaInPodnebjeBg > :first-child > .p-tree-node-content,
:host ::ng-deep .KlimaInPodnebjeBg > :first-child > .p-treenode-content,
:host ::ng-deep .KlimaInPodnebjeBg:first-child > div {
  background-color: #ACC1D4 !important;
  color: white !important;
}
:host ::ng-deep .KlimaInPodnebjeBg .layerOpacitySlider .p-slider-range,
:host ::ng-deep .KlimaInPodnebjeBg .layerOpacitySlider .p-slider-handle {
  background: #ACC1D4 !important;
  border-color: #ACC1D4 !important;
}
:host ::ng-deep .ProstorBg > :first-child > .p-tree-node-content,
:host ::ng-deep .ProstorBg > :first-child > .p-treenode-content,
:host ::ng-deep .ProstorBg:first-child > div {
  background-color: #C1B4CC !important;
  color: white !important;
}
:host ::ng-deep .ProstorBg .layerOpacitySlider .p-slider-range,
:host ::ng-deep .ProstorBg .layerOpacitySlider .p-slider-handle {
  background: #C1B4CC !important;
  border-color: #C1B4CC !important;
}
:host ::ng-deep .ObnViriEnergijeBg > :first-child > .p-tree-node-content,
:host ::ng-deep .ObnViriEnergijeBg > :first-child > .p-treenode-content,
:host ::ng-deep .ObnViriEnergijeBg:first-child > div {
  background-color: #ACD4D3 !important;
  color: white !important;
}
:host ::ng-deep .ObnViriEnergijeBg .layerOpacitySlider .p-slider-range,
:host ::ng-deep .ObnViriEnergijeBg .layerOpacitySlider .p-slider-handle {
  background: #ACD4D3 !important;
  border-color: #ACD4D3 !important;
}
:host ::ng-deep .PrometBg > :first-child .nodeLabel,
:host ::ng-deep .RabaEnergijeBg > :first-child .nodeLabel,
:host ::ng-deep .OskrbaZEnergijoBg > :first-child .nodeLabel,
:host ::ng-deep .OmejitveVProstoruBg > :first-child .nodeLabel,
:host ::ng-deep .KlimaInPodnebjeBg > :first-child .nodeLabel,
:host ::ng-deep .ProstorBg > :first-child .nodeLabel,
:host ::ng-deep .ObnViriEnergijeBg > :first-child .nodeLabel {
  color: white !important;
}
:host ::ng-deep .mapLayerToggleButton.p-togglebutton,
:host ::ng-deep .mapLayerToggleButton.p-togglebutton > button,
:host ::ng-deep .mapLayerToggleButton .p-button {
  width: 17px !important;
  height: 17px !important;
  padding: 0 !important;
  background: transparent !important;
  border: 0 !important;
  box-shadow: none !important;
}
:host ::ng-deep .mapLayerToggleButton .p-button-icon,
:host ::ng-deep .mapLayerToggleButton .pi {
  font-size: 13px !important;
  margin: 0 !important;
}
:host ::ng-deep .mapLayerToggleButton.p-togglebutton,
:host ::ng-deep .mapLayerToggleButton.p-togglebutton > button {
  color: #000 !important;
}
:host ::ng-deep .mapLayerToggleButton.featInfoToggleButton.p-togglebutton,
:host ::ng-deep .mapLayerToggleButton.featInfoToggleButton.p-togglebutton > button {
  color: #d3d3d3 !important;
}
:host ::ng-deep .p-component:focus,
:host ::ng-deep .p-button:focus,
:host ::ng-deep .p-select:focus,
:host ::ng-deep .p-tree-toggler:focus,
:host ::ng-deep *:focus,
:host ::ng-deep *:focus-visible {
  outline: none !important;
  box-shadow: none !important;
}
:host ::ng-deep .PrometBg span.p-button-icon-left.fa.fa-fw.fa-circle-o,
:host ::ng-deep .PrometBg span.p-button-icon-left.fa.fa-fw.fa-dot-circle-o {
  color: #EDDA6B !important;
}
:host ::ng-deep .RabaEnergijeBg span.p-button-icon-left.fa.fa-fw.fa-circle-o,
:host ::ng-deep .RabaEnergijeBg span.p-button-icon-left.fa.fa-fw.fa-dot-circle-o {
  color: #EFC98C !important;
}
:host ::ng-deep .OskrbaZEnergijoBg span.p-button-icon-left.fa.fa-fw.fa-circle-o,
:host ::ng-deep .OskrbaZEnergijoBg span.p-button-icon-left.fa.fa-fw.fa-dot-circle-o {
  color: #D4BFAC !important;
}
:host ::ng-deep .OmejitveVProstoruBg span.p-button-icon-left.fa.fa-fw.fa-circle-o,
:host ::ng-deep .OmejitveVProstoruBg span.p-button-icon-left.fa.fa-fw.fa-dot-circle-o {
  color: #EF988C !important;
}
:host ::ng-deep .KlimaInPodnebjeBg span.p-button-icon-left.fa.fa-fw.fa-circle-o,
:host ::ng-deep .KlimaInPodnebjeBg span.p-button-icon-left.fa.fa-fw.fa-dot-circle-o {
  color: #ACC1D4 !important;
}
:host ::ng-deep .ProstorBg span.p-button-icon-left.fa.fa-fw.fa-circle-o,
:host ::ng-deep .ProstorBg span.p-button-icon-left.fa.fa-fw.fa-dot-circle-o {
  color: #C1B4CC !important;
}
:host ::ng-deep .ObnViriEnergijeBg span.p-button-icon-left.fa.fa-fw.fa-circle-o,
:host ::ng-deep .ObnViriEnergijeBg span.p-button-icon-left.fa.fa-fw.fa-dot-circle-o {
  color: #ACD4D3 !important;
}
:host ::ng-deep .p-tree {
  padding: 0 !important;
  margin: 0 !important;
  border: 0 !important;
  border-radius: 0 !important;
  background: transparent !important;
}
:host ::ng-deep .p-tree-container {
  padding: 0 !important;
  margin: 0 !important;
  border: 0 !important;
}
:host ::ng-deep .p-tree-container > ul {
  padding: 0 !important;
  margin: 0 !important;
}
:host ::ng-deep .tree-dropdown .p-select-label {
  font-size: 12px !important;
}
:host ::ng-deep .layers-tree-dd-panel.p-select-panel {
  font-size: 12px !important;
  border-radius: 12px !important;
  border: 1px solid #d9d9d9 !important;
  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.14) !important;
  overflow: hidden !important;
}
:host ::ng-deep .layers-tree-dd-panel .p-select-items {
  padding: 6px !important;
}
:host ::ng-deep .layers-tree-dd-panel .p-select-item {
  font-size: 12px !important;
  line-height: 14px !important;
  padding: 6px 10px !important;
  border-radius: 10px !important;
  margin: 2px 0 !important;
}
:host ::ng-deep .tree-dropdown.p-select .p-select-label {
  font-size: 12px !important;
  line-height: 14px !important;
}
:host ::ng-deep .layers-tree-dd-panel {
  --p-select-option-selected-background: #ececec !important;
  --p-select-option-selected-color: #000 !important;
  --p-select-option-hover-background: #ececec !important;
  --p-select-option-hover-color: #000 !important;
  --p-select-option-focus-background: #ececec !important;
  --p-select-option-focus-color: #000 !important;
}
:host ::ng-deep .layers-tree-dd-panel .p-select-item.p-focus,
:host ::ng-deep .layers-tree-dd-panel .p-select-option.p-focus,
:host ::ng-deep .layers-tree-dd-panel .p-select-item:focus,
:host ::ng-deep .layers-tree-dd-panel .p-select-option:focus {
  background: #f3f3f3 !important;
  color: #000 !important;
}
:host {
  --tree-iconcell: 22px;
  --tree-line-gap: 10px;
  --controls-indent: calc(var(--tree-iconcell) + var(--tree-line-gap));
  --controls-top-gap: 10px;
}
:host ::ng-deep .tree-controls {
  margin-top: var(--controls-top-gap);
  padding-left: var(--controls-indent);
  width: 100%;
  box-sizing: border-box;
}
:host ::ng-deep .p-tree .p-tree-node-content:hover .p-tree-node-toggle-button,
:host ::ng-deep .p-tree .p-tree-node-content:hover .p-tree-toggler,
:host ::ng-deep .p-tree .p-tree-node-content:hover .p-tree-toggler-button,
:host ::ng-deep .p-tree .p-treenode-content:hover .p-tree-node-toggle-button,
:host ::ng-deep .p-tree .p-treenode-content:hover .p-tree-toggler,
:host ::ng-deep .p-tree .p-treenode-content:hover .p-tree-toggler-button {
  background: transparent !important;
  box-shadow: none !important;
}
:host ::ng-deep .p-tree .p-tree-node-toggle-button:focus,
:host ::ng-deep .p-tree .p-tree-node-toggle-button:focus-visible,
:host ::ng-deep .p-tree .p-tree-toggler:focus,
:host ::ng-deep .p-tree .p-tree-toggler:focus-visible,
:host ::ng-deep .p-tree .p-tree-toggler-button:focus,
:host ::ng-deep .p-tree .p-tree-toggler-button:focus-visible {
  background: transparent !important;
  box-shadow: none !important;
  outline: none !important;
}
:host ::ng-deep .p-tree .p-tree-node-toggle-button,
:host ::ng-deep .p-tree .p-tree-toggler,
:host ::ng-deep .p-tree .p-tree-toggler-button {
  border-radius: 0 !important;
}
:host ::ng-deep .tree-dropdown.p-select {
  display: flex !important;
  align-items: center !important;
}
:host ::ng-deep .tree-dropdown.p-select .p-select-label {
  display: flex !important;
  align-items: center !important;
  justify-content: flex-start !important;
  height: auto !important;
  min-height: 34px !important;
}
:host ::ng-deep .layers-tree-dd-panel {
  overscroll-behavior: contain !important;
}
:host ::ng-deep .layers-tree-dd-panel .p-select-items-wrapper,
:host ::ng-deep .layers-tree-dd-panel .p-select-list-container,
:host ::ng-deep .layers-tree-dd-panel .p-select-items {
  max-height: 260px !important;
  overflow-y: auto !important;
  overscroll-behavior: contain !important;
  -webkit-overflow-scrolling: touch;
}
/*# sourceMappingURL=layers-tree.component.css.map */
